'use client';

import Link from 'next/link';
import React from 'react';

import GuidesSectionStyled from './GuidesSection.styled';
import NoticeSilde from './NoticeSilde/NoticeSlide';

const GuidesSection = () => {
  const GUIDE_LINKS = [
    {
      title: '코튼시드란?',
      svg: '/images/icon/main_guide_kottonseed.svg',
      link: '/story',
      isExternal: false,
    },
    {
      title: '회원가입 안내',
      svg: '/images/icon/main_guide_register.svg',
      link: '/notion/guide/join',
      isExternal: false,
    },
    {
      title: '파트너스 문의',
      svg: '/images/icon/main_guide_transaction.svg',
      link: 'https://naver.me/GalEu3N3',
      isExternal: true,
    },
    {
      title: '인스타그램',
      svg: '/images/icon/main_guide_instagram.svg',
      link: 'https://www.instagram.com/kottonseed',
      isExternal: true,
    },
  ];

  return (
    <GuidesSectionStyled.Container>
      <GuidesSectionStyled.GuideContainer>
        {/* 타이틀 */}
        <GuidesSectionStyled.Title data-nosnippet>코튼시드 가이드</GuidesSectionStyled.Title>

        {/* 링크 아이콘 컨테이너 */}
        <GuidesSectionStyled.GuideLinkContainer>
          {GUIDE_LINKS.map((link) => (
            <Link key={link.title} href={link.link} passHref legacyBehavior data-nosnippet>
              <GuidesSectionStyled.IconLink
                {...(link.isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
                data-nosnippet
              >
                <GuidesSectionStyled.SVGImage
                  src={link.svg}
                  alt="링크 아이콘"
                  width={40}
                  height={40}
                  loading="eager"
                  unoptimized
                  data-nosnippet
                />
                <GuidesSectionStyled.GuideTitle dangerouslySetInnerHTML={{ __html: link.title }} data-nosnippet />
              </GuidesSectionStyled.IconLink>
            </Link>
          ))}
        </GuidesSectionStyled.GuideLinkContainer>
      </GuidesSectionStyled.GuideContainer>
      {/* 공지 슬라이드 */}
      <NoticeSilde />
    </GuidesSectionStyled.Container>
  );
};

export default GuidesSection;
